var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-86a)" },
      React.createElement("circle", { cx: "20", cy: "20", r: "19", stroke: "#303030", strokeWidth: "2" }),
      React.createElement("circle", { cx: "20", cy: "29", r: "1", fill: "#303030" }),
      React.createElement("path", { d: "M18.1248 11.9961C18.0572 10.9144 18.9162 10 20 10C21.0838 10 21.9428 10.9144 21.8752 11.9961L21.0624 25.0019C21.0273 25.563 20.5621 26 20 26C19.4379 26 18.9727 25.563 18.9376 25.0019L18.1248 11.9961Z", fill: "#303030" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-86a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H40V40H0z" })
      )
    )
  );
});